import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { ColorUtil } from '../../../utils/color-util';

export type ListBackgrounds =
  'light' | 'gray' | 'sky blue' | 'light blue' | 'blue' | 'high attention';

export type ListProps = {
  background?: ListBackgrounds;
  children: React.ReactNode;
  className?: string;
  condensed?: boolean;
  name?: string;
  variation?: 'outline' | 'shadow';
};

export const List = ({
  background,
  children,
  className,
  condensed = false,
  name = 'LIST',
  variation = 'outline',
}: ListProps) => {
  return (
    <ul
      data-test={name}
      className={AttrsHelper.formatClassname(
        'list',
        `list-${variation}`,
        background &&
          ColorUtil.nameClass({ color: background, prefix: 'background' }),
        condensed && 'list-condensed',
        className
      )}
    >
      {children}
    </ul>
  );
};
